// extracted by mini-css-extract-plugin
module.exports = {"additionalInvoiceName":"additionalInvoiceName----r9o"};